
import React from 'react';
import {Link, withRouter} from 'react-router-dom';

class WebLink extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {
          link: 'https://langsontrade.vn/',
          banner: require('assets/images/web-links/1.jpg')
        },
        {
          link: 'http://www.dongthaptrade.com.vn/',
          banner: require('assets/images/web-links/2.jpg')
        },
        {
          link: 'http://travinhtrade.vn/',
          banner: require('assets/images/web-links/3.jpg')
        }
      ]
    };
  }

  render() {
    
    return (
      <section className='center highlight-promotion-container'>
        <h2 className='hinghlight-title'><span>LIÊN KẾT</span></h2>
        <div className="container">
          <div className='row'>
            {this.state.data.map((weblink, i) => {
              return (
                <div className='web-link-item'>
                  <a href={weblink.link} target="_blank">
                    <img src={weblink.banner}/>
                  </a>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(WebLink);



// WEBPACK FOOTER //
// ./components/home/WebLink.jsx